{
  "version": 1,
  "asset_id": "ee5b4dff-3ee4-4cb8-8d8f-226dcb99d511",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/ee5b4dff-3ee4-4cb8-8d8f-226dcb99d511/clip-img_0137-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/ee5b4dff-3ee4-4cb8-8d8f-226dcb99d511/clip-img_0137-poster-sm.webp",
  "original_filename": "clip-img_0137-poster-sm.webp",
  "size": 136042,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:08:11Z"
}
